import { COLORS } from '../../constants/theme';

const baseStyle = {
  width: '100%', background: COLORS.bg, border: `1.5px solid ${COLORS.border}`,
  borderRadius: 9, padding: '12px 15px', fontSize: 14.5, color: COLORS.text,
  outline: 'none', transition: 'border-color .18s, background .18s',
  boxSizing: 'border-box', fontFamily: 'Inter, sans-serif',
};

const labelStyle = {
  fontSize: 12.5, fontWeight: 600, color: COLORS.text2, display: 'block', marginBottom: 6,
};

function focusHandlers(e) {
  e.target.style.borderColor = COLORS.blue;
  e.target.style.background  = COLORS.white;
}
function blurHandlers(e) {
  e.target.style.borderColor = COLORS.border;
  e.target.style.background  = COLORS.bg;
}

export default function InputField({ label, as, style, ...props }) {
  const Field = as === 'textarea' ? 'textarea' : 'input';
  return (
    <div>
      {label && <label style={labelStyle}>{label}</label>}
      <Field
        style={{ ...baseStyle, ...style }}
        onFocus={focusHandlers}
        onBlur={blurHandlers}
        {...props}
      />
    </div>
  );
}
